import * as Cf from '../config/Config';
import axios from 'axios';
axios.defaults.headers.common['Authorization'] = 'ReactJSClientWeb';

export function _Post(url, params, callback) {
    axios.post(Cf.default.URL + url, params).then(function (response) {
        if (callback) callback(null, response.response ? response.response : response.data);
        return true;
    }).catch(function (error) {
        if (callback) callback(error, null);
        return true;
    });
}
export function _Get(url, params, callback) {
    axios.get(Cf.default.URL + url, {
        params: params
    }).then(function (response) {
        if (callback) callback(null, response.response ? response.response : response.data);
        return true;
    }).catch(function (error) {
        if (callback) callback(error, null);
        return true;
    });
}
export function _GetF(url, callback) {
    axios.get(url, null).then(function (response) {
        if (callback) callback(null, response.data);
        return true;
    }).catch(function (error) {
        if (callback) callback(error, null);
        return true;
    });
}



// WEBPACK FOOTER //
// ./src/helpers/Network.js